import styled from 'styled-components';

export const BibleStudyHeaderImg = styled.div`
  width: auto;
  height: 100px;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    max-height: 100%;
    max-width: 80%;
    width: auto;
    height: auto;
  }
`;
